import { useCallback, useEffect, useRef } from 'react'
import { useField, useFormikContext } from 'formik'

import type { FormState } from '../formConfig'

export function useFormFields() {
  const { setFieldValue } = useFormikContext<FormState>()

  const customReasonRef = useRef<HTMLInputElement>()

  const [reasonField] = useField<string>('reasonId')
  const [customReasonField] = useField<string>('customReason')
  const [cancelReasonField, { error, touched }] =
    useField<string>('notServicedReason')

  const cancelReasonError = touched ? error : undefined

  const onFocusCustomReason = useCallback(
    () => setFieldValue('reasonId', 'custom'),
    [setFieldValue],
  )

  const customReasonHelperText = `${customReasonField.value.length}/50`

  useEffect(() => {
    if (reasonField.value !== 'custom') {
      setFieldValue('customReason', '')
    } else {
      customReasonRef.current?.focus()
    }
  }, [reasonField.value, setFieldValue])

  return {
    reasonField,
    customReasonRef,
    customReasonField,
    cancelReasonField,
    cancelReasonError,
    onFocusCustomReason,
    customReasonHelperText,
  }
}
